import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing plans.
 */
interface ListPlanRequest {
  queryKey: [number, string, string, string];
}

/**
 * Service class for handling plans.
 */
class PlanService {
  static listPlan(request: ListPlanRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];
    const status = request.queryKey[2];
    const product_id = request.queryKey[3];

    return client.get(
      `admin/plan/list?page=${page_no}&search_text=${searchText}&status=${status}&product_id=${product_id}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new plan based on the provided request.
   *
   * @param request - The request parameters for adding a plan.
   * @returns A Promise that resolves to the Axios response for the add plan request.
   */
  static addPlan(request: any) {
    return client.post("admin/plan/add", request);
  }

  /**
   * Updates the status of a plan based on the provided request.
   *
   * @param request - The request parameters for updating the status of a plan.
   * @returns A Promise that resolves to the Axios response for the update status request.
   */
  static updateStatusPlan(request: any) {
    return client.patch("admin/plan/update-status/", request);
  }

  /**
   * Updates the details of a plan based on the provided request.
   *
   * @param request - The request parameters for updating a plan.
   * @returns A Promise that resolves to the Axios response for the update plan request.
   */
  static updatePlan(request: any) {
    return client.post("admin/plan/edit/", request);
  }

  /**
   * Retrieves the details of a plan based on the provided parameters.
   *
   * @param params - The parameters for retrieving the plan details.
   * @returns A Promise that resolves to the Axios response containing the plan details.
   */
  static viewPlan(params: any) {
    return client.get("admin/plan/get", { params });
  }

  /**
   * Deletes a plan based on the provided parameters.
   *
   * @param params - The parameters for deleting the plan.
   * @returns A Promise that resolves to the Axios response for the delete plan request.
   */
  static deletePlan(params: any) {
    return client.delete("/admin/plan/delete/", { params });
  }

  /**
   * Retrieves the details of a plan based on the provided parameters.
   *
   * @param params - The parameters for retrieving the plan details.
   * @returns A Promise that resolves to the Axios response containing the plan details.
   */
  static viewPlanDetailWithProduct(params: any) {
    return client.get("admin/plan/plan-details", { params });
  }
}

export { PlanService };
